<template>
  <div id="horas-competencia">
    <div class="header-horas">
      <span class="title-horas">Resumo Horas Competência</span>
    </div>
    <div class="horas-orcadas">
      <table class="table table-striped table-sm">
        <thead>
        </thead>
        <tbody>
          <tr>
            <td>Horas Orçadas</td>
            <td>{{ totalOrcado.replace(".", ",") }}</td>
          </tr>
          <tr>
            <td>Horas AMS</td>
            <td>{{ totalAmsAtual.replace(".", ",") }}</td>
          </tr>
          <tr>
            <td>Horas Fábrica</td>
            <td>{{ totalFabricaAtual.replace(".", ",") }}</td>
          </tr>
          <tr>
            <td>Horas Alocação</td>
            <td>{{ horasAlocacao.replace(".", ",") }}</td>
          </tr>
          <tr>
            <td>Total</td>
            <td>{{ getSomatorio }}</td>
          </tr>
          <tr>
            <td>Horas Faltando</td>
            <td>{{ getHorasFaltando }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="header-horas">
      <span class="title-horas">Horas Orçadas</span>
      <button class="btn btn-primary pull-right button-horas" @click="copyHorasOrcadas">Copiar</button>
    </div>
    <div class="horas-orcadas">
      <table id="table-orcadas" class="table table-striped table-sm">
        <thead>
          <th>Sistema</th>
          <th>Status</th>
          <th>Issue</th>
          <th>Horas Orçadas</th>
          <th>Link Issue</th>
        </thead>
        <tbody>
          <tr v-for="horas in horasOrcado" :key="horas.id">
            <td>{{ horas.sistema }}</td>
            <td>{{ horas.status }}</td>
            <td>{{ horas.title }}</td>
            <td>{{ horas.orcado.replace(".", ",") }}</td>
            <td><a :href="linkIssue(horas.sistema, horas.iid)" target="_blank">Ir para Issue</a></td>
          </tr>
          <tr>
            <td>Total</td>
            <td></td>
            <td></td>
            <td>{{ totalOrcado.replace(".", ",") }}</td>
            <td></td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="header-horas-fabrica">
      <span class="title-horas">Horas AMS</span>
      <div class="acoes">
        <span class="text-horas">Competência</span>
        <date-picker input-class="form-control" v-model="periodoInicialAMS" lang="pt-br" format="MM/YYYY" type="month"
          @change="updateFilterAms"></date-picker>
        <button class="btn btn-primary pull-right button-horas" @click="copyHorasAms">Copiar</button>
      </div>
    </div>
    <div class="horas-ams">
      <table id="table-ams" class="table table-striped table-sm">
        <thead>
          <th>Sistema</th>
          <th class="col-8">Issue</th>
          <th class="col-1">Horas Total</th>
          <th class="col-1">Horas Faturadas</th>
          <th class="col-1">Horas Competência</th>
        </thead>
        <tbody>
          <tr v-for="horas in horasAms" :key="horas.id">
            <td>{{ horas.sistema }}</td>
            <td>{{ horas.title }}</td>
            <td>{{ horas.horasTotal.replace(".", ",") }}</td>
            <td>{{ horas.horasFaturado.replace(".", ",") }}</td>
            <td>{{ horas.horasCompetencia.replace(".", ",") }}</td>
          </tr>
        </tbody>
      </table>
      <table class="table table-striped table-sm">
        <tbody>
          <tr>
            <td>Total</td>
            <td class="col-8" />
            <td class="col-1">{{ totalAms.replace(".", ",") }}</td>
            <td class="col-1">{{ totalAmsFaturado.replace(".", ",") }}</td>
            <td class="col-1">{{ totalAmsCompetencia.replace(".", ",") }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="header-horas-fabrica">
      <span class="title-horas">Horas Fábrica</span>
      <div class="acoes">
        <span class="text-horas">Comp. Faturado</span>
        <date-picker
          input-class="form-control"
          v-model="periodoInicialFabrica"
          lang="pt-br"
          format="MM/YYYY"
          type="month"
          @change="updateFilterFabrica"
        />
        <!-- Filtro Fechamento Competência -->
        <span class="text-horas" style="margin-left:8px;">Comp. Repasse</span>
        <date-picker
          input-class="form-control"
          v-model="filtroFechamentoFabrica"
          lang="pt-br"
          format="MMM/YYYY"
          type="month"
          placeholder="Selecione uma data"
          :editable="true"
          clearable
          @change="updateFilterFabrica"
        />
        <!-- Novo filtro Pend. Repasse -->
        <span class="text-horas" style="margin-left:8px;">Pend. Repasse</span>
        <input
          type="checkbox"
          v-model="filtroPendRepasse"
          @change="updateFilterFabrica"
          style="margin-left:4px; margin-right:8px;"
        />
        <button class="btn btn-primary button-horas" @click="copyHorasFabrica">
          Copiar
        </button>
      </div>
    </div>

    <div class="horas-fabrica">
      <table id="table-fabrica" class="table table-striped table-sm">
        <thead>
          <th>Sistema</th>
          <th>Issue</th>
          <th style="white-space: nowrap;">Horas Orçadas</th>
          <th>Comp. Faturado</th>
          <th>Comp. Repasse</th>
          <th>Link Issue</th>
        </thead>
        <tbody>
          <tr v-for="(horas, idx) in horasFabrica" :key="idx">
            <td>{{ horas.sistema }}</td>
            <td>{{ horas.title }}</td>
            <td>{{ horas.orcado.replace(".", ",") }}</td>
            <td>{{ horas.milestone }}</td>
            <td style="min-width: 120px;">
              <date-picker v-model="horas.fechamentoCompetencia" type="month" format="MM/YYYY"
                input-class="form-control" placeholder="Selecione" style="width: 120px;" :editable="true" lang="pt-br"
                @change="onChangeFechamentoCompetencia(horas, idx)" />
            </td>
            <td style="white-space: nowrap;">
              <a :href="linkIssue(horas.sistema, horas.iid)" target="_blank">Ir para Issue</a>
            </td>
          </tr>
          <tr>
            <td>Total</td>
            <td></td>
            <td>{{ totalFabrica.replace(".", ",") }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="scss">
#horas-competencia {
  .header-horas {
    flex-direction: row;
    justify-content: space-between;
    background-color: #2F353B;
    border-radius: 8px;
    padding: 12px;

    .title-horas {
      font-size: 22px;
      color: white;
    }

    .text-horasAMS {
      font-size: 0.875rem;
      color: white;
      margin-left: 62%;
      margin-right: 1%;
    }

    .text-horasFabrica {
      font-size: 0.875rem;
      color: white;
      margin-left: 60%;
      margin-right: 1%;
    }

    .button-horas {
      margin-left: 10px;
      height: 36px;
      margin-bottom: 20px;
      margin-top: 2px;
    }
  }

  .header-horas-fabrica {
    display: flex;
    align-items: center; // alinha verticalmente todos
    background: #2f353b;
    padding: 12px;
    border-radius: 8px;
    flex-wrap: wrap; // permite quebrar em telas menores (remova se não quiser)

    .title-horas {
      font-size: 22px;
      color: #fff;
      white-space: nowrap;
    }

    // bloco B
    .acoes {
      margin-left: auto; // cola todo o bloco na direita
      display: flex;
      align-items: center;
      gap: 8px; // controla o espaço entre filhos
    }

    .text-horas {
      font-size: 0.875rem;
      color: #fff;
      white-space: nowrap;
    }

    // sem margen vertical extra!
    .button-horas {
      height: 36px;
      margin: 0 0 0 8px; // só espaçamento lateral
      white-space: nowrap;
    }
  }
}
</style>


<script>

import DatePicker from "vue2-datepicker";
export default {
  name: 'horas-competencia',
  components: {
    DatePicker,
  },
  data() {
    return {
      horasFabrica: [],
      totalFabrica: 0,
      horasAms: [],
      totalAms: 0,
      totalAmsFaturado: 0,
      totalAmsCompetencia: 0,
      horasOrcado: [],
      totalOrcado: 0,
      horasAlocacao: 0,
      periodoInicialAMS: '',
      periodoInicialFabrica: '',
      dataHoje: new Date().toISOString().split('T')[0],
      totalAmsAtual: 0,
      totalFabricaAtual: 0,
      filtroCompetenciaFabrica: null,
      filtroFechamentoFabrica: null,
      filtroPendRepasse: false,
    };
  },

  computed: {
    getSomatorio() {
      const sum = parseFloat(this.totalOrcado) + parseFloat(this.totalAmsAtual) + parseFloat(this.totalFabricaAtual) + parseFloat(this.horasAlocacao);
      return sum.toString().replace(".", ",");
    },

    getHorasFaltando() {
      const sum = 2000 - (parseFloat(this.totalOrcado) + parseFloat(this.totalAmsAtual) + parseFloat(this.totalFabricaAtual) + parseFloat(this.horasAlocacao));
      return sum.toFixed(2).toString().replace(".", ",");
    },
  },

  async mounted() {
    await this.getHorasFabrica(this.dataHoje);
    await this.getHorasAms(this.dataHoje);
    this.totalAmsAtual = this.totalAmsCompetencia,
      this.totalFabricaAtual = this.totalFabrica,
      this.getHorasOrcadas();
    this.getHorasAlocacao();
  },

  methods: {
    async getHorasFabrica(competencia, fechamento = '', pendRepasse = false) {
      try {
        this.carregando = true;
        // Monta os parâmetros
        let params = {};
        if (competencia !== '' && competencia instanceof Date) {
          params.data = competencia.toISOString().split('T')[0];
        } else {
          params.data = competencia;
        }
        if (fechamento) {
          params.dataFechamento = fechamento;
        }
        if (pendRepasse) {
          params.pendRepasse = true;
        }
        const { data: response } = await this.$http.get('/dashboard/horas-fabrica', { params });
        const temp = [];
        let valueSum = 0;
        this.totalFabrica = 0;
        response.registros.map((item) => {
          // Conversão do fechamentoCompetencia ("mai/2025" ou "05/2025") para objeto Date para o date-picker
          let fechamentoDate = null;
          if (item.fechamentoCompetencia && typeof item.fechamentoCompetencia === 'string') {
            let mesIdx = null, anoStr = '';
            if (/^\d{2}\/\d{4}$/.test(item.fechamentoCompetencia)) {
              // "05/2025"
              const [mesStr, ano] = item.fechamentoCompetencia.split('/');
              mesIdx = parseInt(mesStr, 10) - 1;
              anoStr = ano;
            } else if (/^[a-z]{3}\/\d{4}$/i.test(item.fechamentoCompetencia)) {
              // "mai/2025"
              const [mesStr, ano] = item.fechamentoCompetencia.split('/');
              const meses = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
              mesIdx = meses.indexOf(mesStr.toLowerCase());
              anoStr = ano;
            }
            if (mesIdx !== null && !isNaN(mesIdx) && anoStr) {
              fechamentoDate = new Date(Number(anoStr), mesIdx, 1);
            }
          }
          temp.push({
            iid: item.iid,
            sistema: item.sistema,
            path: item.path,
            title: item.title,
            orcado: item.orcado,
            milestone: item.milestone, // <-- garanta que milestone está aqui
            fechamentoCompetencia: fechamentoDate,
          });
          valueSum += parseFloat(item.orcado.replace(",", "."));
        });
        this.horasFabrica = temp;
        this.totalFabrica = valueSum.toFixed(2);
      } catch (e) {
        console.error(e);
      } finally {
        this.carregando = false;
      }
    },

    async getHorasAms(competencia,) {
      try {
        this.carregando = true;

        const { data: response } = await this.$http.get('/dashboard/horas-ams', {
          params: {
            data: competencia,
          },
        });

        const temp = [];
        let valueSum = 0;
        let valueSum2 = 0;
        let valueSum3 = 0;
        this.totalAms = 0;
        this.totalAmsFaturado = 0;
        this.totalAmsCompetencia = 0;
        response.registros.map((item) => {
          temp.push({
            sistema: item.sistema,
            title: item.title,
            horasTotal: item.horas_total,
            horasFaturado: item.horas_ja_faturado,
            horasCompetencia: item.horas_competencia,
          });
          valueSum += parseFloat(item.horas_total.replace(",", "."));
          valueSum2 += parseFloat(item.horas_ja_faturado.replace(",", "."));
          valueSum3 += parseFloat(item.horas_competencia.replace(",", "."));
        });
        this.horasAms = temp;
        this.totalAms = valueSum.toFixed(2);
        this.totalAmsFaturado = valueSum2.toFixed(2);
        this.totalAmsCompetencia = valueSum3.toFixed(2);
      } catch (e) {
        console.error(e);
      } finally {
        this.carregando = false;
      }
    },

    async getHorasOrcadas() {
      try {
        this.carregando = true;

        const { data: response } = await this.$http.get('/dashboard/horas-orcadas');

        const temp = [];
        let valueSum = 0;
        this.totalOrcado = 0;
        response.registros.map((item) => {
          temp.push({
            iid: item.iid,
            status: item.status,
            sistema: item.sistema,
            title: item.title,
            orcado: item.orcado,
          });
          valueSum += parseFloat(item.orcado.replace(",", "."));
        });
        this.horasOrcado = temp;
        this.totalOrcado = valueSum.toFixed(2);
      } catch (e) {
        console.error(e);
      } finally {
        this.carregando = false;
      }
    },

    async getHorasAlocacao() {
      try {
        this.carregando = true;
        const { data: response } = await this.$http.get('/dashboard/horas-alocacao');
        this.horasAlocacao = parseFloat(response.registros[0].horas_funcionais).toFixed(2);
      } catch (e) {
        console.error(e);
      } finally {
        this.carregando = false;
      }
    },

    copyElementToClipboard(element) {
      window.getSelection().removeAllRanges();
      let range = document.createRange();
      range.selectNode(typeof element === 'string' ? document.getElementById(element) : element);
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
    },

    copyHorasFabrica() {
      // Monta tabela temporária apenas com texto, incluindo Comp. Faturado (milestone) e Comp. Repasse (fechamento)
      let html = `<table><thead><tr>
        <th>Sistema</th>
        <th>Issue</th>
        <th>Horas Orçadas</th>
        <th>Comp. Faturado</th>
        <th>Comp. Repasse</th>
        <th>Link Issue</th>
      </tr></thead><tbody>`;
      this.horasFabrica.forEach(horas => {
        let fechamento = '';
        if (horas.fechamentoCompetencia instanceof Date) {
          const mes = (horas.fechamentoCompetencia.getMonth() + 1).toString().padStart(2, '0');
          const ano = horas.fechamentoCompetencia.getFullYear();
          fechamento = `${mes}/${ano}`;
        } else if (typeof horas.fechamentoCompetencia === 'string') {
          fechamento = horas.fechamentoCompetencia;
        }
        // Mostra o texto "Ir para Issue" como hyperlink
        const link = this.linkIssue(horas.sistema, horas.iid);
        html += `<tr>
          <td>${horas.sistema || ''}</td>
          <td>${horas.title || ''}</td>
          <td>${(horas.orcado || '').replace('.', ',')}</td>
          <td>${horas.milestone || ''}</td>
          <td>${fechamento}</td>
          <td><a href="${link}" target="_blank">Ir para Issue</a></td>
        </tr>`;
      });
      html += `<tr>
        <td>Total</td>
        <td></td>
        <td>${(this.totalFabrica || '').replace('.', ',')}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>`;
      html += '</tbody></table>';

      // Cria elemento temporário para copiar
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      document.body.appendChild(tempDiv);
      this.copyElementToClipboard(tempDiv);
      document.body.removeChild(tempDiv);
    },

    copyHorasAms() {
      this.copyElementToClipboard('table-ams');
    },

    copyHorasOrcadas() {
      this.copyElementToClipboard('table-orcadas');
    },

    linkIssue(sistema, issueId) {
      const sistemaMap = {
        'Autorizações': 'autorizacoes',
        'APP Beneficiário': 'app-beneficiario',
        'App Beneficiario RN': 'app-beneficiario-rn',
        'APP Cooperado': 'app-cooperado',
        'Call Center Intercâmbio': 'call-center-intercambio',
        'Componentes Unimed': 'componentes-unimed',
        'compras OPME': 'compras-opme',
        'Contas a Pagar': 'contas-a-pagar',
        'Contas Médicas': 'contas-medicas',
        'EFD Reinf': 'efd',
        'Gestão de Cursos 2.0': 'gestao-de-cursos-2-0',
        'Guia Médico': 'guia-medico',
        'HUB Intercâmbio': 'hub-intercambio',
        'Livros Auxiliares': 'livros-auxiliares',
        'Notificações': 'notificacoes',
        'Novo Interfat': 'novo-interfat',
        'Pagamentos da Diretoria': 'pagamentos-da-diretoria',
        'Portal de Contratantes': 'portal-de-contratantes',
        'Portal Tiss': 'portal-tiss',
        'Rotinas Unimed': 'rotinas-unimed',
        'Teleconsulta - Web': 'teleconsulta-web',
        'Web Autorizações': 'web-autorizacoes'
      };
      const sistemaFormatado = sistemaMap[sistema] || sistema;
      const baseUrl = 'https://gitlab.meta.com.br/unimed';
      return `${baseUrl}/${sistemaFormatado}/-/issues/${issueId}`;
    },
    async updateFilterAms(date) {
      let formattedDate = '';
      if (date === null) {
        date = this.dataHoje;
      } else {
        formattedDate = date.toISOString().split('T')[0];
      }
      try {
        await this.getHorasAms(formattedDate);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    async updateFilterFabrica() {
      // Monta competencia
      let competencia = this.periodoInicialFabrica;
      // Monta fechamento
      let fechamento = '';
      if (this.filtroFechamentoFabrica instanceof Date) {
        const meses = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
        const mes = meses[this.filtroFechamentoFabrica.getMonth()];
        const ano = this.filtroFechamentoFabrica.getFullYear();
        fechamento = `${mes}/${ano}`;
      }
      // Se Pend. Repasse está marcado e não há outros filtros, NÃO manda dataHoje (manda só pendRepasse)
      if (
        this.filtroPendRepasse &&
        (!competencia || competencia === '') &&
        (!fechamento || fechamento === '')
      ) {
        await this.getHorasFabrica('', '', true);
        return;
      }

      // Se ambos filtros estiverem vazios, chama com dataHoje
      if ((!competencia || competencia === '') && (!fechamento || fechamento === '') && !this.filtroPendRepasse) {
        await this.getHorasFabrica(this.dataHoje, '', false);
        return;
      }
      await this.getHorasFabrica(competencia, fechamento, this.filtroPendRepasse);
    },
    onChangeFechamentoCompetencia(horas, idx) {
      let data = horas.fechamentoCompetencia;
      let dataFormatada = '';
      if (data instanceof Date) {
        // Salva no formato MM/YYYY
        const meses = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
        const mes = meses[data.getMonth()];
        const ano = data.getFullYear();
        dataFormatada = `${mes}/${ano}`;
        horas.fechamentoCompetencia = data;
      } else if (typeof data === 'string') {
        dataFormatada = data;
      }
      const id = horas.iid;
      console.log('Fechamento competência selecionado:', dataFormatada, '| ID:', id);

      // Chamada GET igual ao postAtualizarEtapa
      this.$http.get('/dashboard/update-fechamento-competencia', {
        params: {
          iid: id,
          fechamento_competencia: dataFormatada,
          sistema: horas.sistema,
        }
      }).then(response => {
        if (response.data && response.data.success) {
          // opcional: this.$toasted.success('Fechamento atualizado com sucesso!');
        } else {
          // opcional: this.$toasted.error(response.data.message || 'Erro ao atualizar fechamento.');
        }
      }).catch(error => {
        // opcional: this.$toasted.error('Erro ao atualizar fechamento competência');
        // console.error('Erro ao atualizar fechamento competência', error);
      });
    },
  }
};

</script>
